/** Profile: account & settings only (loan setup lives under `/loan`). */
export const PROFILE_PATH = {
  settings: '/profile/settings',
} as const;

export function isProfileAreaPath(pathname: string): boolean {
  return pathname === '/profile' || pathname.startsWith('/profile/');
}
